import React, { useEffect, useState } from "react";
import axios from "axios";

import Navbar from "./components/Navbar";
import Footer from "./components/Footer";

import {
  Container,
  Typography,
  Box,
  Button,
  Stack,
  Tooltip
} from "@mui/material";
import CloudDownloadIcon from "@mui/icons-material/CloudDownload";
import DescriptionIcon from "@mui/icons-material/Description";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";

const BingoPage2 = () => {
  const openPdf = filename => {
    window.open("/api/file5_2_1/" + encodeURIComponent(filename), "_blank");
  };
  const openPdf2 = filename => {
    window.open("/api/file5_2_2/" + encodeURIComponent(filename), "_blank");
  };

  // 9-grid handlers
  const handle9Questions = () => openPdf("บัตรคำถามสีแดง.pdf");
  const handle9Sheets = () => openPdf("แผ่นเล่นเกม9ช่อง12แบบสีแดง.pdf");
  const handle9Instructions = () =>
    openPdf("วิธีเล่นเกมบิงโกปอดไม่แหก_แดง.pdf");

  // 25-grid handlers
  const handle25Questions = () => openPdf2("บัตรคำถามแบบเขียว.pdf");
  const handle25Sheets = () => openPdf2("แผ่นเล่น25ช่อง12แบบเขียว-resized.pdf");
  const handle25Instructions = () =>
    openPdf2("วิธีเล่นเกมบิงโกปอดไม่แหก_เขียว.pdf");

  return (
    <React.Fragment>
      <Navbar />

      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          minHeight: "100vh" // ทำให้สูงเท่าหน้าจอ
        }}
      >
        <Container sx={{ textAlign: "center", maxWidth: "md" }}>
          <Typography
            gutterBottom
            sx={{
              mt: 18,
              mb: 10,
              fontWeight: 700,
              fontFamily: "Poppins, sans-serif",
              textAlign: "center",
              background: "linear-gradient(90deg, #3F51B5, #00BCD4)",
              WebkitBackgroundClip: "text",
              WebkitTextFillColor: "transparent",
              fontSize: { xs: "1.4rem", sm: "1.6rem", md: "1.8rem" },
              textShadow: "1px 1px 2px rgba(0,0,0,0.08)",
              letterSpacing: "0.8px",
              lineHeight: 1.4
            }}
          >
            เกมบิงโกปอดไม่แหก
          </Typography>

          <Box sx={{ mt: 4, textAlign: "left" }}>
            <Typography sx={{ fontWeight: 700, mb: 2, fontSize: "1.4rem" }}>
              เกมบิงโก “ปอดไม่แหก” แบบตารางเกม 9 ช่อง
            </Typography>
            <Stack
              direction={{ xs: "column", sm: "row" }}
              spacing={2}
              sx={{ mb: 3 }}
            >
              <Tooltip title="บัตรคำถาม">
                <Button
                  variant="contained"
                  startIcon={<HelpOutlineIcon />}
                  onClick={handle9Questions}
                  sx={{
                    minWidth: 220,
                    height: 56,
                    fontWeight: 700,
                    textTransform: "none"
                  }}
                >
                  บัตรคำถาม
                </Button>
              </Tooltip>

              <Tooltip title="แผ่นเล่นเกม 9 ช่อง 12 แบบ">
                <Button
                  variant="outlined"
                  startIcon={<DescriptionIcon />}
                  onClick={handle9Sheets}
                  sx={{
                    minWidth: 260,
                    height: 56,
                    fontWeight: 700,
                    textTransform: "none"
                  }}
                >
                  แผ่นเล่นเกม 9 ช่อง 12 แบบ
                </Button>
              </Tooltip>

              <Tooltip title="วิธีเล่นเกมบิงโกปอดไม่แหก 9 ช่อง">
                <Button
                  variant="contained"
                  color="primary"
                  startIcon={<CloudDownloadIcon />}
                  onClick={handle9Instructions}
                  sx={{
                    minWidth: 320,
                    height: 56,
                    fontWeight: 700,
                    textTransform: "none"
                  }}
                >
                  วิธีเล่นเกมบิงโกปอดไม่แหก 9 ช่อง
                </Button>
              </Tooltip>
            </Stack>
            <br /> <br />
            <Typography sx={{ fontWeight: 700, mb: 2, fontSize: "1.4rem" }}>
              เกมบิงโก “ปอดไม่แหก” แบบตารางเกม 25 ช่อง
            </Typography>
            <Stack
              direction={{ xs: "column", sm: "row" }}
              spacing={2}
              sx={{ mb: 3 }}
            >
              <Tooltip title="บัตรคำถาม">
                <Button
                  variant="contained"
                  startIcon={<HelpOutlineIcon />}
                  onClick={handle25Questions}
                  sx={{
                    minWidth: 220,
                    height: 56,
                    fontWeight: 700,
                    textTransform: "none"
                  }}
                >
                  บัตรคำถาม
                </Button>
              </Tooltip>

              <Tooltip title="แผ่นเล่น 25 ช่อง 12 แบบ">
                <Button
                  variant="outlined"
                  startIcon={<DescriptionIcon />}
                  onClick={handle25Sheets}
                  sx={{
                    minWidth: 260,
                    height: 56,
                    fontWeight: 700,
                    textTransform: "none"
                  }}
                >
                  แผ่นเล่น 25 ช่อง 12 แบบ
                </Button>
              </Tooltip>

              <Tooltip title="วิธีเล่นเกมบิงโกปอดไม่แหก 25 ช่อง">
                <Button
                  variant="contained"
                  color="primary"
                  startIcon={<CloudDownloadIcon />}
                  onClick={handle25Instructions}
                  sx={{
                    minWidth: 320,
                    height: 56,
                    fontWeight: 700,
                    textTransform: "none"
                  }}
                >
                  วิธีเล่นเกมบิงโกปอดไม่แหก 25 ช่อง
                </Button>
              </Tooltip>
            </Stack>
          </Box>
        </Container>
      </Box>

      <Footer />
    </React.Fragment>
  );
};

export default BingoPage2;
